import * as React from "react";

const SvgIcnVoiceSmall = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M7.5 6a.5.5 0 01.5.5v11a.5.5 0 11-1 0v-11a.5.5 0 01.5-.5zm4-2a.5.5 0 01.5.5v15a.5.5 0 11-1 0v-15a.5.5 0 01.5-.5zm4 4a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm-6 0a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm4 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm12 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5z"
                fill="currentColor"
            />
        </g>
    </svg>
);

export default SvgIcnVoiceSmall;
